module.exports = __webpack_public_path__ + "media/images/playpass_logo-f7a265647e20f874aedb13dca01dfd60.png";